import { useContext } from "react";

import { commanderContext } from "../contexts/commander";

export const useSendCommand = () => useContext(commanderContext);
